import { render, staticRenderFns } from "./QrLanguageMenu.vue?vue&type=template&id=4c254f07&scoped=true&"
import script from "./QrLanguageMenu.vue?vue&type=script&lang=js&"
export * from "./QrLanguageMenu.vue?vue&type=script&lang=js&"
import style0 from "./QrLanguageMenu.vue?vue&type=style&index=0&id=4c254f07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c254f07",
  null
  
)

export default component.exports